// material-ui
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, IconButton, Typography } from '@mui/material';
import logo from "../../../assets/logo-login.png"

// project imports




// types
import PropTypes from 'prop-types';

// assets
// import { IconMenu2 } from '../../../../node_modules/@tabler/icons-react';
import { MdDashboard } from 'react-icons/md';
import { CiMenuKebab } from "react-icons/ci";
import { IoMdMenu } from "react-icons/io";
import customtheme from '../../../themes';
import defaultTheme from '../../../themes/defaultTheme';
import { useSelector } from 'react-redux';
import { BsBoxArrowLeft } from 'react-icons/bs';
import { useContext } from 'react';
import { ContextUserInfo } from '../../MainLayout/index';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {

    const { userInfo} = useContext(ContextUserInfo);
    const getUserName = () => {
        var res = '';
        if (userInfo)
          res = userInfo.firstName + ' ' + userInfo.lastName;
        return res;
      }
      const exitToApp = () => {

        localStorage.clear();
      
        window.location.pathname = "/login";
      }
    return (
        <>

   <ThemeProvider theme={defaultTheme}>
   <div style={{ width: '100%' }}>
              <Box
                sx={{ display: 'flex' }}
              >
               <Box sx={{ width: '100%' }}> <Typography component="h1" variant="h6" sx={{ display: "flex", alignItems: "center",mt:2 }}>
                  <IconButton color="inherit" onClick={() => exitToApp()}>
                  <BsBoxArrowLeft />
                  </IconButton><span style={{fontSize:16}}>{getUserName()}</span>
                </Typography></Box>
                <Box sx={{ width: '100%' }}> </Box> 
                <Box sx={{ flexShrink: 0 }}> <Typography component="h1" variant="h5" sx={{fontFamily: 'BFarnaz !important',
                  fontSize: { xs: '1rem', sm: '1rem', md: '2rem' }, mt:3.5, mr: 3.5,display: { xs: 'none', sm: 'none', md: 'block' } }}>داشبورد سامانه های عمره
                </Typography>  </Box>
                <Box sx={{ flexShrink: 0 }}>
                  <img id="headerlogoimage" src={logo} alt="موسسه عمره سعادت" />
                </Box>
                <Box
                sx={{
                    width: 50,
                    display: 'flex',
                   
                }}
            >
       <IconButton color="inherit" onClick={handleLeftDrawerToggle}>
       <CiMenuKebab />
                  </IconButton>
                
               
            </Box>
           
              </Box>
            </div> 
            
            
           
            </ThemeProvider>

        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
